module.exports = __webpack_public_path__ + "img/HC1030-05.1de44a5e.jpg";